import { PatchJson } from "./helpers";

export async function EventThemePackMigration(event: number, token: string): Promise<any> {
	return PatchJson({
		path: `/v3/admin/events/theme-packs/migration/${event}`,
		token,
		data: {},
	});
}
